<script>

	import { onMount } from 'svelte'
	import { createEventDispatcher } from 'svelte'
	import { fade, slide } from 'svelte/transition'

    import SignUpService from '../services/signup'
    import { notifications } from '../services/notification'
  	
	const dispatch = createEventDispatcher()

    let username = ""
	let visible = false

    onMount(async () => {})

	export const start = async () => {
		visible = true
	}

	export const stop = (action = 'close', data = {}) => {
		dispatch('message', {
			action : action,
            data : data
		})
        username = ""
		visible = false
	}

    const generateLink = async () => {

        if(!username) return

        let sresult = await SignUpService.generate({ username : username })
        if(sresult.success) stop('update', sresult)
        if(!sresult.success) {
            error = sresult.data
            notifications.danger(sresult.data)
        }
    }

	const handleClose = () => {
		stop()
	}

</script>

{#if visible}
    <div class="fullscreen" on:click={handleClose} transition:fade="{{ y: 200, duration: 200 }}"></div>
    <div class="container main-modal" transition:slide="{{ x: -200, duration: 200 }}">
        <div class="row p-0 m-0">
            <div class="col p-0 m-0"></div>
            <div class="col-auto p-0 m-0">
                <button type="button" class="btn-close" aria-label="Close" on:click="{stop}"></button>
            </div>
        </div>        
        <div class="row justify-content-center">
            <div class="col-md-12">

                <h2 class="text-center"  id="users">Nouveau Lien</h2>
                
                <div class=" mt-4">
                    <input type="text" bind:value={username} class="p-2 w-100" placeholder="Nom"/>
                </div>
                
            </div>    
        </div>
        <div class="row justify-content-center">
            <div class="col-md-6 text-left">
                <div class=" mt-4">
                    <button type="button" on:click={generateLink} class="btn btn-dark w-100">Créer</button>
                </div> 
            </div>
        </div>
    </div>
{/if}

<style>

    .fullscreen {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom : 0;
        background-color: rgba(0, 0, 0, 0.33);
    }

	.main-modal {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: white;
        border-radius: 15px;
        max-width: 100%;
        padding: 10px 35px 35px 35px;
        max-height: 100%;
        width: 500px;
        overflow: auto;
	}

</style>
